import { useState } from 'react';
import { faqData } from '../../../mocks/faq';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-20 lg:py-28 bg-cream-100">
      <div className="max-w-[1000px] mx-auto px-6 lg:px-12">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold text-center text-brown-600 mb-16">
          よくある質問
        </h2>
        
        <div className="space-y-4">
          {faqData.map((faq) => (
            <article
              key={faq.id}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-cream-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg md:text-xl font-serif font-semibold text-brown-600 pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`${
                    openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'
                  } text-2xl text-brown-400 flex-shrink-0 w-8 h-8 flex items-center justify-center`}
                ></i>
              </button>
              
              {openId === faq.id && (
                <div className="px-6 pb-6">
                  <p className="text-base text-brown-500 leading-relaxed font-serif">
                    {faq.answer}
                  </p>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
      
      {/* Structured Data for FAQ */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqData.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
}